<template>
  <div>
    <!-- Ko snosi troškove section -->
    <div class="mb-4">
      <div class="subtitle-1 font-weight-bold text-uppercase mb-3 black--text">
        {{ $t("who_pays_costs") }}
      </div>

      <v-alert border="left" color="blue lighten-5" class="mb-4" :icon="false" dense>
        <v-row no-gutters align="center">
          <v-icon color="amber" class="mr-2">mdi-lightbulb-on-outline</v-icon>
          <strong>{{ $t("help") }}</strong>
        </v-row>

        <div class="mt-1">{{ $t("who_pays_costs_help") }}</div>
      </v-alert>

      <v-radio-group v-model="selectedPaymentType" hide-details class="mt-0">
        <v-card
          v-for="option in paymentTypeOptions"
          :key="option.value"
          class="payment-option-card mb-3"
          outlined
        >
          <v-card-text class="py-3">
            <v-radio :value="option.value" color="deep-orange">
              <template v-slot:label>
                <div>
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2" :color="option.iconColor">
                      {{ option.icon }}
                    </v-icon>
                    <span class="font-weight-medium">{{ $t(option.label) }}</span>
                  </div>
                  <div class="option-description">
                    {{ $t(option.description) }}
                  </div>
                </div>
              </template>
            </v-radio>
          </v-card-text>
        </v-card>
      </v-radio-group>
    </div>

    <!-- What happens when user exceeds limit - shown only for company_and_user -->
    <div v-if="selectedPaymentType === 'company_and_user'" class="mb-4">
      <autocomplete
        :label="$t('what_happens_when_limit_exceeded')"
        v-model="limitExceededAction"
        :items="limitExceededOptions"
        item-text="text"
        item-value="value"
        dense
        outlined
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentCreditsTab",
  props: {
    wideLayout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedPaymentType: "company_pays",
      limitExceededAction: "pay_difference",
      paymentTypeOptions: [
        {
          value: "company_pays",
          icon: "mdi-office-building",
          iconColor: "blue darken-1",
          label: "company_pays",
          description: "company_pays_description",
        },
        {
          value: "company_and_user",
          icon: "mdi-account-cash",
          iconColor: "orange darken-2",
          label: "company_and_user",
          description: "company_and_user_description",
        },
        {
          value: "user_pays",
          icon: "mdi-account",
          iconColor: "purple darken-1",
          label: "user_pays",
          description: "user_pays_description",
        },
        {
          value: "company_deducts_salary",
          icon: "mdi-cash-minus",
          iconColor: "red darken-1",
          label: "company_deducts_salary",
          description: "company_deducts_salary_description",
        },
        {
          value: "company_deducts_and_pays_restaurant",
          icon: "mdi-cash-refund",
          iconColor: "green darken-1",
          label: "company_deducts_and_pays_restaurant",
          description: "company_deducts_and_pays_restaurant_description",
        },
      ],
      limitExceededOptions: [
        { value: "pay_difference", text: this.$t("user_pays_difference") },
        { value: "pay_full_meal", text: this.$t("user_pays_full_meal_price") },
      ],
    };
  },
};
</script>

<style scoped>
.payment-option-card {
  transition: all 0.2s ease;
}

.payment-option-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.option-description {
  font-size: 0.813rem;
  color: #757575;
  line-height: 1.4;
}
</style>
